<template>
  <div class="my-container">
    <b-container class="pl-0 mb-2 pr-0">
      <b-row>
        <sidebar />
      </b-row>
      <b-row class="mt-4">
        <b-col class="pl-0 pr-0">
          <p class="title">{{ title }}</p>
        </b-col>
        <b-col class="d-flex justify-content-end pr-0 pl-0">
          <sign-out-button class="button" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import signOutButton from "@/components/signOutButton.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";

export default {
  data() {
    return {
      title: "UNIDADES"
    };
  },
  components: {
    signOutButton,
    Sidebar
  },
  mounted() {
    let ruta = this.$route.fullPath;
    switch (ruta) {
      case "/unidades":
        this.title = "UNIDADES";
        break;
      case "/recibos":
        this.title = "ADMINISTRAR RECIBOS";
        break;
      case "/cobranza":
        this.title = "COBRANZA";
        break;
      case "/socio":
        this.title = "SOCIO Y USUARIO";
        break;
      case "/recibos-cobranza":
        this.title = "RECIBOS DE COBRANZA";
        break;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../assets/sass/global.sass"

.button
  @include font-buttons
  color: $blue
  background-color: $white
  border: $white

.title
  font-family: $tipo-letra
  font-size: 20px
  font-style: italic

.button:hover, .button:active, .button:focus, .button:active:focus
  background-color: $blue !important
  color: $white

.titles
  font-family: $tipo-letra
  font-size: 20px
  font-style: italic

.my-container
  margin-right: auto
  margin-left: auto
  background: #2376d2
  color: white
  padding-bottom: 10px
  margin-bottom: 10px
  box-shadow: 0px 0px 6px 0px black

@media only screen and (max-width: 1350px)
  .my-container
    padding-left: 10%
    padding-right: 5%
</style>
